import React from "react";
import { Card } from "react-bootstrap";

export default function Footer() {
  return (
    <Card>
      <Card.Header>Footer</Card.Header>
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p>This is the footer content. Need to design.</p>
          <footer className="blockquote-footer">
            Someone famous in <cite title="Source Title">Source Title</cite>
          </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}
